import React, {  } from 'react'
import { IonPage, IonHeader, IonToolbar, IonTitle, IonContent, IonIcon, IonBackButton, IonButtons, IonFab, IonFabButton, IonFabList, IonLoading } from '@ionic/react'
import { funnel, add } from 'ionicons/icons'
import { APPLINKS } from '../../resources/AppConst'
import InvoiceTable from './InvoiceTable'
import { useInvoiceList } from '../../contexts/useInvoiceList'

const InvoiceList = (props) => {

    const { Invoices , InvList , setInvList, showLoading, setShowLoading, editBill , printBill , removeBill, viewBill  } = useInvoiceList()

    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonBackButton />
                    </IonButtons>
                    <IonTitle>Invoice List</IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent className='ion-padding'>
                
                <InvoiceTable data={InvList} editBill={editBill} printBill={printBill} removeBill={removeBill} viewBill={viewBill} />

                <IonFab vertical="top" horizontal="end" slot="fixed" edge>
                    <IonFabButton>
                        <IonIcon icon={funnel} />
                    </IonFabButton>
                    <IonFabList side='start'>
                        <IonFabButton color='danger' size='small' onClick={() => {
                            let gstbills = Invoices.filter((bill) => bill.gstEnabled)
                            setInvList(gstbills)
                        }}>GST</IonFabButton>
                        <IonFabButton size="small" onClick={() => {
                            let normbills = Invoices.filter((bill) => !bill.gstEnabled)
                            setInvList(normbills)
                        }}>Normal</IonFabButton>
                        <IonFabButton color='success' size="small" onClick={() => {
                            setInvList(Invoices)
                        }}>All</IonFabButton>
                    </IonFabList>
                </IonFab>

                <IonFab vertical="bottom" horizontal="end" slot="fixed" onClick={() => { props.history.push(APPLINKS.createInvoice) }}>
                    <IonFabButton color='danger'>
                        <IonIcon icon={add} />
                    </IonFabButton>
                </IonFab>

            </IonContent>

            <IonLoading
                isOpen={showLoading}
                onDidDismiss={() => setShowLoading(false)}
                message={'Please wait...'}
                duration={5000}
            />
            <iframe className='ion-hide' id='print' title='Print Invoice'></iframe>
        </IonPage>
    )
}

export default InvoiceList
